import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import ucaEnv from "../env/env-uca";
import { localConfig } from "./LocalToken";
const banner = document.getElementById("banner").dataset.banner;
const env = document.getElementById("env").dataset.env;
const isLocal = false; // TODO : While running local make it as true else false
const environmentVariables = ucaEnv(banner, env, "web");
const excludeUrls = [
  environmentVariables.AUTH_API,
  "https://abs-qa1.oktapreview.com/oauth2/ausdvuyculRIYitXg0h7/v1/token",
];
const htppRequest = (options = {}) => {
  const { headers = {} } = options;
  const httpService = axios.create({
    headers: { ...headers },
  });
  // Request interceptor
  httpService.interceptors.request.use(
    async function (config) {
      config.headers = {
        ...config.headers,
      };
      const exclude = excludeUrls.find((url) => config.url.includes(url));
      if (!exclude) {
        let token = "";
        try {
          if (isLocal) {
            const res = await httpService(localConfig);
            if (res && res.data && res.data["access_token"]) {
              // localStorage.setItem('token', res.data["access_token"])
              token = res.data["access_token"];
            }
          } else {
            const res = await httpService.get(
              `${environmentVariables.AUTH_API}&rand=${uuidv4()}`,
              { withCredentials: true }
            );
            if (res && res.data && res.data["SWY_SHOP_TOKEN"]) {
              // localStorage.setItem('token', res.data["SWY_SHOP_TOKEN"])
              token = res.data["SWY_SHOP_TOKEN"];
            }
          }
        } catch (err) {}
        config.headers = {
          "Content-Type": "application/json",
          "Ocp-Apim-Subscription-Key":
            environmentVariables.REWARDS_PAGE_APIM_SUBSCRIPTION_KEY,
          Authorization: `Bearer ${token}`,
          "X-Banner-Id": banner,
        };
      }
      return config;
    },
    function (error) {
      return Promise.reject(error);
    }
  );
  // Response interceptor
  httpService.interceptors.response.use(
    (response) => {
      // Any status code that lie within the range of 2xx cause this function to trigger
      // Do something with response data
      return Promise.resolve(response);
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  return httpService;
};
export default htppRequest();
